import {FormFieldTypes} from '@constants/pages/form-page/form-field-types';

export class FormPage {
  id: number = 0;
  label: string = '';
  type: FormType = FormType.BASIC;
  projectId: string = '';
  dataset: string = '';
  tableName: string = '';
  inputFields: InputField[] = [];
}

export enum FormType {
  BASIC = 'BASIC', FLATNESS = 'FLATNESS'
}

export class InputField {
  id: number = -1;
  columnName: string = '';
  label: string = '';
  index: number = -1;
  datatype: DataType | string = '';
  topX: number = -1;
  topY: number = -1;
  width: number = -1;
  height: number = -1;
  placeholder: string = '';
  value: string = '';
  valueList: string[] = [];
  lowerBound: number = -1;
  upperBound: number = -1;
  dropdown: boolean = false;
  options: string[] = [];
  required: boolean = false;
  list: boolean = false;
  isCollapsed?: boolean = true;
  formFieldType?: FormFieldTypes;
  isValidConfiguration?:boolean = true;
}

export enum DataType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  TIMESTAMP = 'TIMESTAMP'
}
